
export default {
  name: 'MenuItem',

  data: function () {
    return {
      isOpen: false,
    };
  },

  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },

  computed: {
    isChildren: function () {
      return Boolean((this.data?.children || []).length);
    },
  },

  methods: {
    clickLink: function () {
      if (!this.isChildren) {
        this.$router.push(`/${this.data.path}`);
        this.closeMobileMenu();
        return;
      }

      this.isOpen = !this.isOpen;
    },
    clickChildrenLink: function () {
      this.$refs.refItem.classList.remove('children');
      setTimeout(() => {
        this.$refs.refItem.classList.add('children');
      }, 500);
      this.isOpen = false;

      this.closeMobileMenu();
    },

    closeMobileMenu: function () {
      this.$store.commit('mobile-menu/closeMenu');
    },
  },
};
